/**
 * Resource danh mục nội dung chi phí
 * ndhieu3 21.04.2023
 */
export default {
  FundStructure: {
    PlaceholderSearchText: 'Tìm kiếm theo Mã nội dung chi phí, Tên nội dung chi phí',
  },
  FundStructureDetail: {
    FundStructureDetailCode: 'Mã nội dung chi phí *',
    FundStructureDetailName: 'Tên nội dung chi phí *',
    BelongFundStructure: 'Thuộc nội dung chi phí',
  },
};
